import MobileTableCard from 'src/components/Tables/cards/MobileTableCard';
import TableV2 from 'src/components/Tables/TableV2';
import { DownloadRecordType, s3DateStringToDate } from '@drift/common';
import {
	getExportsTableDataTitleFromType,
	getExportsTableLiquidatee,
} from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryExportsTable/ExportsTable/utils';
import { AccountData } from 'src/stores/useDriftAccountsStore';

interface Props {
	fileType: DownloadRecordType;
	marketSymbol: string | undefined;
	recordUserKey: string | undefined;
	deletedAccounts: Partial<AccountData>[] | undefined;
	accounts: AccountData[];
	requestedDate: string;
	fromDate: string;
	toDate: string;
}

export default function ExportsTableMobileCard({
	fileType,
	marketSymbol,
	recordUserKey,
	deletedAccounts,
	accounts,
	requestedDate,
	fromDate,
	toDate,
}: Props) {
	const dataTitle = getExportsTableDataTitleFromType(fileType);
	const liquidatee = getExportsTableLiquidatee({
		marketSymbol,
		recordUserKey,
		deletedAccounts,
		accounts,
	});

	return (
		<MobileTableCard.Root className="gap-y-lg">
			<div className="grid w-full grid-cols-2">
				<MobileTableCard.LabelWithValue
					label="Data"
					className="capitalize"
					value={dataTitle}
				/>
				<MobileTableCard.LabelWithValue
					label="Account / Market"
					className="items-end"
					value={liquidatee}
				/>
			</div>
			<div className="grid w-full grid-cols-2">
				<MobileTableCard.LabelWithValue
					label="Start Date"
					value={
						<TableV2.DateCell
							date={s3DateStringToDate(fromDate)}
							className="w-fit py-0 whitespace-nowrap"
							displayAsTimestamp
							hideTime
						/>
					}
				/>
				<MobileTableCard.LabelWithValue
					label="End Date"
					className="items-end"
					value={
						<TableV2.DateCell
							date={s3DateStringToDate(toDate)}
							className="w-fit py-0 whitespace-nowrap"
							displayAsTimestamp
							hideTime
						/>
					}
				/>
			</div>
			<MobileTableCard.LabelWithValue
				label="Generating Date"
				className="flex-row items-center gap-x-xs"
				value={
					<TableV2.DateCell
						date={s3DateStringToDate(requestedDate)}
						className="w-fit py-0 whitespace-nowrap"
						displayAsTimestamp
						hideTime
					/>
				}
			/>
		</MobileTableCard.Root>
	);
}
